<template>
  <el-table
    v-loading="loading"
    class="mt-xl"
    header-row-class-name="table-header"
    :data="data"
    size="small"
  >
    <el-table-column
prop="order"
label="STT"
align="center"
width="50">
      <template slot-scope="scope">
        {{ scope.row.extra.info.order }}
      </template>
    </el-table-column>
    <el-table-column
      v-for="(c, index) in columns"
      :key="index"
      :prop="c.key"
      :label="c.label"
      :align="c.align"
      :width="c.width"
      :min-width="c.min_width"
    >
      <template slot-scope="scope">
        <span v-if="c.key === 'type'">
          <el-tag>{{ c | getTagValue(scope.row) }}</el-tag>
        </span>
        <span v-else-if="c.key === 'fields'">
          {{ scope.row.extra[c.key] ? scope.row.extra[c.key].length : 0 }}
        </span>
        <span v-else-if="c.key === 'is_publish'">
          <el-switch
            :value="scope.row.extra[c.key]"
            active-text="Publish"
            @change="(v) => $emit('publish', scope.row, v)"
          />
        </span>
        <span v-else-if="c.key === 'created'">
          {{ scope.row.created | convertDateTime('DD-MM-YYYY') }}
        </span>
        <span v-else>
          {{ scope.row.extra[c.key] }}
        </span>
      </template>
    </el-table-column>
    <el-table-column
label="Thao tác"
width="140"
fixed="right"
align="center">
      <template slot-scope="scope">
        <Buttons
          :item="scope.row"
          :buttons="['config', 'edit', 'delete']"
          @edit="(v) => $emit('edit', v)"
          @delete="(v) => $emit('delete', v)"
          @config="(v) => $emit('config', v)"
        />
      </template>
    </el-table-column>
  </el-table>
</template>

<script>
import Buttons from "@/components/items/Buttons.vue";
import CONSTANTS from "@/config/constants";

export default {
  name: "CardList",
  components: {
    Buttons,
  },
  props: {
    data: Array,
    loading: Boolean,
  },
  computed: {
    columns() {
      return [
        {
          label: "Mã đối tượng",
          key: "key",
          min_width: 150,
        },
        {
          label: "Tên đối tượng",
          key: "name",
          min_width: 200,
        },
        {
          label: "Loại đối tượng",
          key: "type",
          options: CONSTANTS.OBJECT_TYPES,
          min_width: 150,
        },
        {
          label: "Trạng thái",
          key: "is_publish",
          align: "center",
          min_width: 150,
        },
        {
          label: "Trường dữ liệu",
          key: "fields",
          align: "center",
        },
        {
          label: "Ngày tạo",
          key: "created",
          align: "center",
        },
      ];
    },
  },
  methods: {},
};
</script>

<style lang="scss"></style>
